import { TourActions } from 'aria-viewer/tour'
import { setMainMediaStalling, setMainMediaPhotoPlayerBoundingRect } from 'aria-viewer/tour/tourActions'
import { UPDATE_VIEWPORT_DIMENSIONS } from 'aria-viewer/device/deviceActions'
import { MEDIA_LOADING_STATUS } from 'aria-viewer/tour/constants'
import { Observable } from 'rxjs/Rx'
import { distinctUntilChanged } from 'rxjs/operators'
import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/takeWhile'
import { MEDIA_TYPES } from 'aria-viewer/tour/constants'
import { PHOTOPLAY_BLURIMAGE, PHOTOPLAYER } from 'aria-viewer/players/photoplayer/photoPlayer'
import { imgLoaded } from 'aria-viewer/utils/functions'

const mediaLoading = action =>
    action.type == TourActions.MAIN_MEDIA_LOADING_STATUS && action.loadingStatus == MEDIA_LOADING_STATUS.loading

const mediaLoaded = action =>
    action.type == TourActions.MAIN_MEDIA_LOADING_STATUS && action.loadingStatus == MEDIA_LOADING_STATUS.loaded

export default (action$, store) => {
    const mediaLoading$ = action$
        .filter(mediaLoading)
        .distinctUntilChanged()
        .switchMap(action =>
            Observable.of(action)
                .delay(500)
                // Photos may not have unmounted thus not calling onload when served from cache.
                // Therefore we'll check if the image has loaded directly from the dom element.
                .takeWhile(
                    _ =>
                        !(
                            store.getState().getIn(['tour', 'mainMedia', 'mediaType']) == MEDIA_TYPES.photo &&
                            imgLoaded(document.getElementById(PHOTOPLAY_BLURIMAGE))
                        )
                )
                .mapTo(setMainMediaStalling(true))
                .takeUntil(action$.filter(mediaLoaded))
        )

    const mediaLoaded$ = action$.filter(mediaLoaded).distinctUntilChanged()

    const toggleStallingFalse$ = mediaLoaded$.switchMap(action =>
        Observable.of(action)
            .takeWhile(_ => store.getState().getIn(['tour', 'mainMedia', 'stalling']))
            .mapTo(setMainMediaStalling(false))
    )

    const setPhotoPlayerBounds$ = Observable.merge(mediaLoaded$, action$.ofType(UPDATE_VIEWPORT_DIMENSIONS))
        .filter(
            _ =>
                store.getState().getIn(['tour', 'mainMedia', 'mediaType']) == MEDIA_TYPES.photo &&
                document.getElementById(PHOTOPLAYER)
        )
        .map(_ => {
            const photoPlayer = document.getElementById(PHOTOPLAYER)

            const photoPlayerBoundingRect = photoPlayer.getBoundingClientRect()

            return setMainMediaPhotoPlayerBoundingRect(photoPlayerBoundingRect)
        })

    return Observable.merge(mediaLoading$, mediaLoaded$, toggleStallingFalse$, setPhotoPlayerBounds$)
}
